// themeConfig.js - Domain-based theme configuration

import { resolveDomainConfig } from "./domainResolver";

const { baseURL } = resolveDomainConfig();

// '--primary-color-acc': '#8B5CF6',
// '--primary-hover-acc': '#7C3AED',
// '--secondary-color-acc': '#F5F3FF',
// '--third-color-acc': '#EDE9FE',

const accessoriesTheme = {
  "--primary-color-acc": "#72bf48",
  "--primary-hover-acc": "#5e9b3c",
  "--secondary-color-acc": "#f7fff2",
  "--third-color-acc": "#F0FDF4",
  "--disable-color-acc": "#eaf5e4",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const godownTheme = {
  "--primary-color-godown": "#2F80ED",
  "--primary-hover-godown": "#2563eb",
  "--secondary-color-godown": "#f2f7ff",
  "--third-color-godown": "#dbeafe",
  "--disable-color-godown": "#e0ecfc",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const handyweltTheme = {
  "--primary-color-mobile": "#1a9e3f",
  "--primary-hover-mobile": "#158635",
  "--secondary-color-mobile": "#f0fdf4",
  "--third-color-mobile": "#dcfce7",
  "--disable-color-mobile": "#d1fae5",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const almasTheme = {
  "--primary-color-mobile": "#111111",
  "--primary-hover-mobile": "#000000",
  "--secondary-color-mobile": "#f7f7f7",
  "--third-color-mobile": "#ececec",
  "--disable-color-mobile": "#e5e5e5",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const mobileTheme = {
  "--primary-color-mobile": "#2F80ED",
  "--primary-hover-mobile": "#2563eb",
  "--secondary-color-mobile": "#f2f7ff",
  "--third-color-mobile": "#dbeafe",
  "--disable-color-mobile": "#e0ecfc",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const THEMES = {
  [process.env.REACT_APP_ACCESSORIES_URL]: accessoriesTheme,
  [process.env.REACT_APP_ACCESSORIES_GODDOWN_URL]: godownTheme,
  [process.env.REACT_APP_HANDYWELT_URL]: handyweltTheme,
  [process.env.REACT_APP_ALMAS_URL]: almasTheme,
  [process.env.REACT_APP_KOLEN_URL]: almasTheme,
  [process.env.REACT_APP_PARTS_URL]: {
    "--primary-color-parts": "#db2e31",
    "--primary-hover-parts": "#b92124",
    "--secondary-color-parts": "#fff2f2",
    "--third-color-parts": "#fff6f7",
    "--disable-color-parts": "#fae0e0",
    "--white": "#FFFFFF",
    "--black": "#000000",
  },
  [process.env.REACT_APP_API_URL]: mobileTheme,
  [process.env.REACT_APP_BERLIN_URL]: mobileTheme,
  [process.env.REACT_APP_NEW_BUYPHONE_URL]: mobileTheme,
};

const DEFAULT_THEME = {
  "--primary-color-mobile": "#2F80ED",
  "--primary-hover-mobile": "#2563eb",
  "--secondary-color-mobile": "#f2f7ff",
  "--third-color-mobile": "#dbeafe",
  "--disable-color-mobile": "#e0ecfc",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const THEME = THEMES[baseURL] ?? DEFAULT_THEME;

export const ICONS = {
  mobile: {
    productConfirmation: require("../assets/product-confirmation-svg.svg")
      .default,
  },

  accessories: {
    accProductConfirmation:
      require("../assets/acc/acc-product-confirmation-svg.svg").default,
  },
  parts: {
    partsProductConfirmation:
      require("../assets/parts/parts-product-confirmation-svg.svg").default,
  },
};

export const ORDER_ICONS = {
  mobile: {
    TotalOrdersSvg: require("../assets/total-orders-svg.svg").default,
    PartsTotalOrdersSvg: require("../assets/parts/parts-total-orders-svg.svg")
      .default,
    AccTotalOrdersSvg: require("../assets/acc/acc-total-orders-svg.svg")
      .default,
  },
};

export const getIcon = (iconKey, isPartsURL, isAccessoriesURL, isGodownURL) => {
  const iconMap = {
    productConfirmation: {
      parts: "partsProductConfirmation",
      accessories: "accProductConfirmation",
      mobile: "productConfirmation",
    },
  };

  const mappedKey = iconMap[iconKey];
  if (!mappedKey) return ICONS.mobile[iconKey];

  if (isPartsURL) return ICONS.parts[mappedKey.parts];
  if (isAccessoriesURL || isGodownURL) return ICONS.accessories[mappedKey.accessories];
  return ICONS.mobile[mappedKey.mobile];
};

export const getOrderIcon = (iconKey, isPartsURL, isAccessoriesURL, isGodownURL) => {
  const iconMap = {
    TotalOrdersSvg: {
      parts: "PartsTotalOrdersSvg",
      accessories: "AccTotalOrdersSvg",
      mobile: "TotalOrdersSvg",
    },
  };

  const mappedKey = iconMap[iconKey];
  if (!mappedKey) return ORDER_ICONS.mobile[iconKey];

  if (isPartsURL) return ORDER_ICONS.parts[mappedKey.parts];
  if (isAccessoriesURL || isGodownURL) return ORDER_ICONS.accessories[mappedKey.accessories];
  return ORDER_ICONS.mobile[mappedKey.mobile];
};

export default THEME;
